// extracted by mini-css-extract-plugin
export default {"lds-ring":"LoadingSpinner_lds-ring__sPCY4","lds-ring--md":"LoadingSpinner_lds-ring--md__2h3Tm","lds-ring--sm":"LoadingSpinner_lds-ring--sm__GoNwW"};